import {
  Contact,
  Insured,
  Owner,
} from '../interfaces/creation-lock-payload.interface';
import { PersonalDataFormFields } from '../interfaces/third-step-payload.interface';

export function mapAddressLine2ForIdefend(
  address2: string | null | undefined,
): string {
  return (address2?.trim() ?? '') === '' ? ' ' : address2;
}

function mapContactType(clientType: string): 'person' | 'company' {
  return clientType === 'individual' ? 'person' : 'company';
}

function mapPhoneNumber(person: PersonalDataFormFields): string | undefined {
  if (person.phonePrefix == null && person.phone == null) {
    return undefined;
  }
  return `${person.phonePrefix ?? ''}${person.phone ?? ''}`;
}

/** Maps form personal data to an iDefend Contact (e.g. vehicle owner). */
export function mapPersonalDataToContact(
  person: PersonalDataFormFields,
  options: { includeContactDetails?: boolean } = {},
): Contact {
  const includeContactDetails = options.includeContactDetails ?? false;
  const contact: Contact = {
    type: mapContactType(person.clientType),
    address: {
      addressLine1: person.address1,
      addressLine2: mapAddressLine2ForIdefend(person.address2),
      street: person.address1,
      city: person.city,
      postCode: person.postalCode,
      countryCode: 'PL',
    },
    identificationNumber: person.idNumber,
  };

  if (person.clientType === 'individual') {
    contact.firstName = person.firstName;
    contact.lastName = person.lastName;
  } else {
    contact.companyName = person.companyName;
  }

  if (includeContactDetails) {
    contact.phoneNumber = mapPhoneNumber(person);
    contact.email = person.email;
  }

  return contact;
}

/** Maps form personal data to an iDefend Insured / PolicyHolder party. */
export function mapPersonalDataToInsured(
  person: PersonalDataFormFields,
  options: { includeContactDetails?: boolean } = {},
): Insured {
  const includeContactDetails = options.includeContactDetails ?? false;
  const insured: Insured = {
    type: mapContactType(person.clientType),
    address: {
      addressLine1: person.address1,
      addressLine2: mapAddressLine2ForIdefend(person.address2),
      street: person.address1,
      city: person.city,
      postCode: person.postalCode,
      countryCode: 'PL',
    },
    firstName: person.firstName ?? '',
    lastName: person.lastName ?? '',
    companyName: person.companyName,
    identificationNumber: person.idNumber,
  };

  if (includeContactDetails) {
    insured.phoneNumber = mapPhoneNumber(person);
    insured.email = person.email;
  }

  return insured;
}

export function mapPersonalDataToOwner(person: PersonalDataFormFields): Owner {
  return {
    contact: mapPersonalDataToContact(person),
  };
}
